/**
* Drupal views configuration
*/
module.config(function ($stateProvider) {
    'use strict';
    $stateProvider.state('node', {
        url: '/node/:id', // TODO : translate or not ?
        controller: function ($state, $stateParams, drupal, $filter) {
            drupal.getNode($stateParams.id).then(function (node) {
                if (node.type === 'internship') {
                    $state.go('internship.detail', { id: node.field_product });
                } else if (node.type === 'product') {
                    $state.go('shop.product', { id: node.field_product });
                } else if (node.type === 'c_article' || node.type === 'c_actualite' || node.type === 'c_action') {
                    $state.go('newsdetail', { id: node.nid });
                } else if (node.type === 'p_page_generic' || node.type === 'p_page_ensemble_widget') {
                    $state.go('section', { id: node.field_identifier });
                } else {
                    // widget or other ressources
                    $state.go('404');
                }
            });
        }
    });
});
